<template>
    <div class="page-user-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">同城配送</div>
            <div class="breadcrumb-item">公司列表</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="150">
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>商家名稱</span>
                                        </div>
                                        <Input v-model="form.name" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>商家標識</span>
                                        </div>
                                        <Input v-model="form.mark" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>首重</span>
                                        </div>
                                        <InputNumber v-model="form.frist_cost" max="100" min="0" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>續重</span>
                                        </div>
                                        <InputNumber v-model="form.renewal_cost" max="100" min="0" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>澳運國際分帳(百分比)</span>
                                        </div>
                                        <InputNumber v-model="form.divide_equally_enterprise" max="100" min="0" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>商家分帳(百分比)</span>
                                        </div>
                                        <InputNumber v-model="form.delide_equally_my" max="100" min="0" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>超期費時間</span>
                                        </div>
                                        <InputNumber v-model="form.outtime_day" max="10" min="0" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>充值餘額</span>
                                        </div>
                                        <InputNumber v-model="form.balance" max="99999" min="0" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>說明備註</span>
                                        </div>
                                        <Input v-model="form.description" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">增加</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                    <!-- <Button type="error" :loading="true" class="loading-btn">
                                         <span>Loading...</span>
                                     </Button>-->
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                pageParam: {},
                detail: {},
                isSubmiting: false,
                form: {
                    name: '',
                    mark: '',
                    free_shipping: '',
                    frist_cost: '',
                    renewal_cost: '',
                    divide_equally_enterprise: '',
                    delide_equally_my: '',
                    balance: '',
                    description: '',
                    outtime_day: ''
                }
            };
        },
        methods: {
            formatDate(datetime)
            {
                if (!datetime) return '';
                let dateTime = new Date(datetime);
                let year = dateTime.getFullYear();
                let month = dateTime.getMonth() + 1;
                let date = dateTime.getDate();
                let hour = dateTime.getHours();
                let minute = dateTime.getMinutes();
                let second = dateTime.getSeconds();
                let milliseconds = dateTime.getMilliseconds();
                return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
            },
            formatNum(num)
            {
                return num < 10 ? '0' + num : num;
            },
            handleBack()
            {
                this.$router.go(-1);
            },
            handleCheckForm()
            {
                let form = this.form;

                if (form.name === '')
                {
                    this.$Utils.showTipInfo('請輸入商家名稱');
                    return;
                } else if (form.mark === '')
                {
                    this.$Utils.showTipInfo('請輸入商家標識');
                    return;
                } else if (form.balance === '')
                {
                    this.$Utils.showTipInfo('請輸入首重');
                    return;
                } else if (form.renewal_cost === '')
                {
                    this.$Utils.showTipInfo('請選擇續重');
                    return;
                } else if (form.description === '')
                {
                    this.$Utils.showTipInfo('請輸入澳運國際分帳(百分比)');
                    return;
                } else if (form.delide_equally_my === '')
                {
                    this.$Utils.showTipInfo('請輸入商家分帳(百分比)');
                    return;
                } else if (form.divide_equally_enterprise === '')
                {
                    this.$Utils.showTipInfo('請選擇充值餘額');
                    return;
                } else if (form.frist_cost === '')
                {
                    this.$Utils.showTipInfo('請選擇說明備註');
                    return;
                } else if (form.outtime_day === '')
                {
                    this.$Utils.showTipInfo('請選擇超期時間');
                    return;
                }
                this.handleSubmit();
            },

            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.samecityAdminAdd,
                    method: 'post',
                    data: {
                        id: form.id,
                        name: form.name,
                        mark: form.mark,
                        balance: form.balance,
                        renewal_cost: form.renewal_cost,
                        description: form.description,
                        delide_equally_my: form.delide_equally_my,
                        divide_equally_enterprise: form.divide_equally_enterprise,
                        frist_cost: form.frist_cost,
                        outtime_day: form.outtime_day
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess(res.msg);
                        this.form = {
                            id: '',
                            name: '',
                            mark: '',
                            balance: '',
                            renewal_cost: '',
                            description: '',
                            delide_equally_my: '',
                            divide_equally_enterprise: '',
                            frist_cost: '',
                            outtime_day: ''
                        };
                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "samecityMasterlistAdd.scss";
</style>